import { createContext } from 'react';

export const API_BASE_URL = 'https://api.capassurances.net/api/v1';
export const APP_NAME = "CAP_ASSURANCE_WEBSITE";
export const LOCAL_STORAGE_KEYS = {
   ACCESS_TOKEN: 'clientAccessToken',
   CURRENT_CLIENT: 'currentClient'
};

export const ClientAuthContext = createContext('CLIENT_AUTH_CONTEXT');
